import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Settings</div>
        <div className="page-subtitle">System configuration</div>
      </div>
    </>
  ),
});
